import users from './users';
import roles from './roles';

export default {
  users,
  roles,
};
